export default {"src":"/gb/en/_next/static/media/BBA_Winner_Best_current_account_provider.285489b6.svg","height":64,"width":235,"blurWidth":0,"blurHeight":0};